export enum ThirdPartySsoName {
    bricks = 'bricks',
    chipsoft = 'chipsoft',
    healthconnected = 'healthconnected',
    medicom = 'medicom',
    medikit = 'medikit',
    microhis2 = 'microhis2',
    mira = 'mira',
    omnihis = 'omnihis',
    optoconnect = 'optoconnect',
    promedico = 'promedico',
    sanday_his = 'sanday_his',
    testHisKsyos = 'test-his-ksyos',
    tetrahis = 'tetrahis',
    zorgdossier = 'zorgdossier',
}
